import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContentApp from '../../../../components/ContentApp';
import ContentBottom from '../../../../components/ContentBottom';
import Header from '../../../../components/Common/Header/Header';
import ButtonProccessing from '../../../../components/Common/ButtonProccessing/ButtonProccessing';
import { useDispatch, useSelector } from 'react-redux';

const Additionaltransferinformation = ({ history }) => {
  const { t } = useTranslation();
  const [specialRequests, setSpecialRequests] = useState('');
  const dispatch = useDispatch();
  const state = useSelector((state) => state.reservation);
  const handleContinue = () => {
    dispatch({
      type: 'RESERVATION_INFO',
      payload: {
        ...state,
        specialRequests,
      },
    });

    history.push('/form-check-transfer');
  };

  const handleInputChange = (e) => {
    setSpecialRequests(e.target.value);
  };

  return (
    <>
      <Header />

      <ContentApp classes='pb-0 fade-up'>
        <div className={`order-details `}>
          <div className='fw-600 font-1rem'>{t('additionalInformation')}</div>
          <div className='fw-400 font-tiny text-tertiary mt-2 pb-3'>
            {t('specialInstructionsHint')}
          </div>

          <div className='mt-3'>
            {/* <label
              htmlFor='specialRequests fw-600 font-small'
              style={{ color: 'var(--color-lighter-gray)' }}
            >
              {t('specialRequests')}
            </label> */}
            <textarea
              id='specialRequests'
              className={`special-requests-container font-small outline-none`}
              value={specialRequests}
              onChange={handleInputChange}
              placeholder={t('specialRequestsPlaceholder')}
              rows={4}
            />
          </div>
        </div>
      </ContentApp>

      <ContentBottom>
        <ButtonProccessing
          status='NORMAL'
          text={t('continue')}
          size='large'
          type='submit'
          onClick={handleContinue}
          arrow
          color='#000'
          backgroundColor='var(--color-primary)'
          iconColor='#000'
        />
      </ContentBottom>
    </>
  );
};

export default Additionaltransferinformation;
